var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu_dropdown actions_dropdown actions_dropdown-hover mar0"},[_c('ActionsMenu',{attrs:{"caseDetails":_vm.caseDetails},on:{"updatepetition":_vm.updatepetition}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }